var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-md-5 pt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai Preventivi")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Preventivo")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-md-3 align-items-end"
              },
              [
                _c("div", { staticClass: "col-md-4 pb-0" }, [
                  _c("h5", { staticClass: "grey pt-0 pb-0" }, [
                    _vm._v("\n          Totale Preventivi: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(" " + _vm._s(_vm.countPractices))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v(
                      "\n          Totale Fatturato verso Clienti:\n          "
                    ),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(_vm._f("formatNumber")(_vm.countCashClient))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v(
                      "\n          Totale da Cessione del Credito:\n          "
                    ),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " + _vm._s(_vm._f("formatNumber")(_vm.countCashInst))
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-10 col-md-4 center pl-5 pr-5" },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: _vm.totCash,
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm._f("formatNumber")(_vm.totCash))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturabili")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.filterValues($event)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey mobSearchT" }, [
                        _vm._v("Ricerca Preventivo")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter,
                              expression: "filter"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Preventivo o Cognome ....."
                          },
                          domProps: { value: _vm.filter },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filter = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    { key: "1231dsdfh32354134", staticClass: "pb-5 mt-4" },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 9
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-9" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Preventivo N. "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [_vm._v(_vm._s(item.code))]
                                            ),
                                            _vm._v(
                                              " del\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .moment(item.created_at)
                                                    .format("DD-MM-YYYY HH:mm")
                                                ) +
                                                " (\n                    " +
                                                _vm._s(item.bonus) +
                                                " ) per\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.client_name) +
                                                  " " +
                                                  _vm._s(item.client_lastname) +
                                                  " "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-primary m-2 btn-sm",
                                              attrs: {
                                                href:
                                                  item.invoice_quotation_pdf,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "print",
                                                  size: "sm"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    visualizza/stampa/scarica\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-green m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "acceptInvoice",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "clipboard-check",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Conferma preventivo\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "editInvoice",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "edit",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Modifica\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-danger m-2 btn-sm mr-md-5",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeOrder(
                                                    item.id,
                                                    item.code,
                                                    key
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                     ARCHIVIA\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "inline-block center relative mt-3"
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "qrcodeImg",
                                              attrs: { src: item.qrcode }
                                            }),
                                            _vm._v(" "),
                                            _c("br"),
                                            _c(
                                              "small",
                                              { staticClass: "qrcodeText" },
                                              [
                                                _c("b", [
                                                  _vm._v("Conferma con")
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "greenLinkAccordion Regular"
                                          },
                                          [_vm._v("Dettagli")]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _c("b", [
                                              _vm._v("Indirizzo dell'immobile")
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.building_address) +
                                              " " +
                                              _vm._s(item.building_civic) +
                                              "\n                  " +
                                              _vm._s(item.building_city) +
                                              " (" +
                                              _vm._s(item.building_province) +
                                              ") CAP:\n                  " +
                                              _vm._s(item.building_zip) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _c(
                                            "h5",
                                            { staticClass: "black pb-0" },
                                            [
                                              _c("b", [
                                                _vm._v("Dati dell'intervento")
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _vm._v(
                                          "\n                  Tipo:\n                  "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "uppercase" },
                                          [
                                            _vm._v(
                                              _vm._s(item.intervention_type)
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "badger-accordion",
                    { key: "1231243412512354134", staticClass: "pb-5 mt-4" },
                    [
                      _vm.hasRemovedPractics
                        ? _c(
                            "badger-accordion-item",
                            { attrs: { id: "id_closed" } },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "h5",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Preventivi Archiviati\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "p",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Attenzione! i dati della dashboard non includono il valori di\n                preventivi archiviati.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    { staticClass: "pb-5 mt-4 greyBg" },
                                    _vm._l(_vm.practicesFiltred, function(
                                      item,
                                      key
                                    ) {
                                      return item.status == 9 &&
                                        _vm.filter == ""
                                        ? _c(
                                            "badger-accordion-item",
                                            {
                                              key:
                                                item.code +
                                                "_r_" +
                                                _vm.countloop,
                                              attrs: { id: "id" + item.code }
                                            },
                                            [
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "center",
                                                  slot: "header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Preventivo N.\n                          "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.code
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " del\n                          " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .moment(
                                                                        item.created_at
                                                                      )
                                                                      .format(
                                                                        "DD-MM-YYYY HH:mm"
                                                                      )
                                                                  ) +
                                                                  "\n                          ( " +
                                                                  _vm._s(
                                                                    item.bonus
                                                                  ) +
                                                                  " ) per\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.client_name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.client_lastname
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary m-2 btn-sm",
                                                              attrs: {
                                                                href:
                                                                  item.invoice_quotation_pdf,
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "print",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          visualizza/stampa/scarica\n                        "
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-danger m-2 btn-sm mr-md-5",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.removeOrder(
                                                                    item.id,
                                                                    item.code,
                                                                    "restore"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "trash-restore-alt",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          Ripristina\n                        "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass: "col-md-3"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "bbaLightColor",
                                                  slot: "content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Indirizzo dell'immobile"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.building_address
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item.building_civic
                                                              ) +
                                                              "\n                        " +
                                                              _vm._s(
                                                                item.building_city
                                                              ) +
                                                              " (" +
                                                              _vm._s(
                                                                item.building_province
                                                              ) +
                                                              ") CAP: " +
                                                              _vm._s(
                                                                item.building_zip
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Dati dell'intervento"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Tipo:\n                        "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "uppercase"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.intervention_type
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Data:\n                        "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "uppercase"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .moment(
                                                                      item.intervention_date
                                                                    )
                                                                    .format(
                                                                      "DD-MM-YYYY"
                                                                    )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v("Nessun risultato per " + _vm._s(_vm.filter))
                  ])
                ]
              )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular center h0 widthFull" }, [
        _c("b", [_vm._v("I tuoi preventivi")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8b643a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b643a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerte/index.vue
// module id = null
// module chunks = 